import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csidentifier(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Identifier tutorial For Beginners</title>
 <meta name="description" content="C# identifier tutorial for beginners.identifier in C# blank space special symbol is not allowed ,it must begin with a letters,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# identifier,c# identifier for,c sharp identifier,c# continue,identifier foreach c#,c# foreach identifier" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-identifier" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">C# Identifier </h1>
    <div className="first">
        <a href="/csharp-variable">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-input">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    
    <p className="mt-4 para"><span className="bold">1, Identifier In c#</span> is a name given to a variable, method.<br/>
2, Blank space special symbol is not allowed <br/>
3, It must begin with letters<br/>
4, You only type less than 31 characters long <br/>
5, You don’t use any keyword in same manner means or Uppercase and lowercase are different means <br/>
</p>

<h2 className='headings'>Uppercase and Lowercase example</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-10"> my_name </span>
            {"\n"}{"\n"}    
                <span className="qwerty-10"> My_Name</span> 
                {"\n"}{"\n"} 
            </code>
          </pre>
          </div> 
          
<h2 className="mt-4 mh2">Rules of identifier in c# :</h2>
<h3  className="headings"> 1, Blank Space Special Symbol in c#</h3>
<div style = {{background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px" }}>
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-10"> code</span>
                <span className="qwerty-3">-</span>
                <span className="qwerty-10">exampler</span>
                <span className="qwerty-3"> = </span>
                <span className="qwerty-7">false</span>            
            {"\n"}{"\n"}
              <span className="qwerty-10"> code</span>
              <span className="qwerty-3">.</span>
              <span className="qwerty-10">exampler</span>
              <span className="qwerty-3"> = </span>
              <span className="qwerty-7">false</span>          
          {"\n"}{"\n"}
            <span className="qwerty-10"> code</span>
            <span className="qwerty-10">_</span>
            <span className="qwerty-10">exampler</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-7">true</span>        
          {"\n"}{"\n"}
          <span className="qwerty-10"> codeexampler</span>
          <span className="qwerty-3"> = </span>
          <span className="qwerty-7">true</span>      
          {"\n"}{"\n"}
        <span className="qwerty-10"> code exampler</span>
        <span className="qwerty-3"> = </span>
        <span className="qwerty-7">false</span>
        {"\n"}{"\n"}
         </code>
         </pre>
         </div>
<h3 className="headings">2, It Must Begin With Letters Identifier in Csharp Example:</h3>

<div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{ maxHeight :"100vh"}}>
    <code >
      {"\n"}
          <span className="qwerty-5"> int</span>
          <span className="qwerty-10"> -2a</span>                
          <span className="qwerty-3">;</span>
          <span className="qwerty-11"> - </span>
          <span className="qwerty-7">wrong </span>
      {"\n"}{"\n"}
          <span className="qwerty-5"> int</span>
          <span className="qwerty-10"> a2</span>                
          <span className="qwerty-11"> - </span>
          <span className="qwerty-7">true</span>
          <span className="qwerty-3">; </span>            
      {"\n"}{"\n"}
          <span className="qwerty-5"> int</span>
          <span className="qwerty-10"> _24a</span>                
          <span className="qwerty-11"> - </span>
          <span className="qwerty-7">false</span>                       
          {"\n"}{"\n"}
   </code>
   </pre>
   </div>
<h3 className="headings">3, We Don’t use any Reserved keyword means:<br/></h3>



<div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-5"> int</span>
                <span className="qwerty-4"> if</span>
                <span className="qwerty-3">;</span>
                <span className="qwerty-11"> - </span>
                <span className="qwerty-7">false</span>             
            {"\n"}{"\n"}
                <span className="qwerty-5"> int</span>
                <span className="qwerty-4"> IF</span>
                <span className="qwerty-3">;</span>
                <span className="qwerty-11"> - </span>
                <span className="qwerty-7">true</span>       
                {"\n"}{"\n"}            
         </code>
         </pre>
         </div> 


<h3 className="headings">4, We only type less than 31 characters long <br/></h3>

<div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-5"> int</span>
                <span className="qwerty-10"> a</span>                
                <span className="qwerty-3"> ; </span>
                <span className="qwerty-2"> &#47;&#47; this declare a variable means 'a' is a variable</span>
                  
            {"\n"}{"\n"}
              <span className="qwerty-10"> a</span>
              <span className="qwerty-3"> = </span>                
              <span className="qwerty-10">4</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-2"> &#47;&#47; this assigns 4 to (a) means assigns a variable a value</span>       
              {"\n"}{"\n"}
         </code>
         </pre>
         </div>  

  <h1 className="mt-5">  </h1>
      
  <div className="back">
        <a href="/csharp-variable">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-input">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csidentifier;